export const CHECKOUT_URL = 'https://nursing-en.impultienda.ar/checkout/';

export const images = {
  mockup: 'https://cdn.magicpatterns.com/uploads/pRfHSbR3BDFqwKsw7Gx7Rv/MOCKUP_NURSING-EN.png',
  rachel: 'https://cdn.magicpatterns.com/uploads/3keXvm8cbPXE95KPWkXFUp/Rachel_Bennett_-_NURSING.png',
};

export const beforeItems = [
  'You spend too much time searching through textbooks, notes, and disconnected reference materials.',
  'You memorize monitoring parameters but struggle to organize their physiological context.',
  'You find it difficult to connect cardiovascular, respiratory, and neurological assessment concepts.',
  'You repeatedly review the same information because your resources are scattered.',
  'You want to practice clinical reasoning but lack organized educational case exercises.',
  'You have accumulated plenty of study materials, yet you still need a consistent reference system.',
];

export const afterItems = [
  'You have six organized volumes covering essential critical care nursing concepts.',
  'You can review selected hemodynamic parameters through structured educational references.',
  'You can study respiratory assessment and ventilation fundamentals in one dedicated volume.',
  'You can organize your review of neurological and cardiovascular assessment concepts.',
  'You can use structured worksheets and checklists to support your study sessions.',
  'You can practice organizing clinical information through simulated educational cases.',
];

export const painPoints = [
  {
    icon: 'heart',
    title: 'You want to understand hemodynamic monitoring better.',
    text: 'You encounter parameters such as mean arterial pressure, cardiac output, and central venous pressure, and you want a clearer reference for understanding what they represent and what their limitations are.',
  },
  {
    icon: 'clock',
    title: 'You spend too much time searching for study materials.',
    text: 'You have textbooks, saved documents, and notes scattered across different places. You want to bring the essential concepts together in one organized collection.',
  },
  {
    icon: 'lungs',
    title: 'You want a more structured way to study respiratory assessment.',
    text: 'You want to review oxygenation, ventilation, arterial blood gas concepts, and mechanical ventilation terminology through organized educational materials.',
  },
  {
    icon: 'brain',
    title: 'You want to connect different areas of critical care assessment.',
    text: 'You know that neurological, cardiovascular, respiratory, and laboratory findings can be related. You want educational resources that help you study these areas together.',
  },
  {
    icon: 'book',
    title: 'You want more than a collection of definitions.',
    text: 'You want comparison tables, visual summaries, worksheets, and structured explanations that make it easier to review complex topics.',
  },
  {
    icon: 'pen',
    title: 'You want to practice your clinical reasoning.',
    text: 'You want educational cases that encourage you to organize findings, recognize missing information, and explain your reasoning instead of simply memorizing facts.',
  },
];

export const studyTools = [
  {
    icon: 'pen',
    title: 'The Critical Care Concept Review Worksheet',
    text: 'A reusable worksheet for organizing definitions, physiological concepts, key questions, and areas requiring further study.',
  },
  {
    icon: 'chart',
    title: 'The Hemodynamic Parameter Comparison Matrix',
    text: 'A visual reference for comparing selected parameters, their meanings, influencing factors, and interpretation limitations.',
  },
  {
    icon: 'lungs',
    title: 'The Respiratory Monitoring Reference Sheet',
    text: 'An organized educational summary of selected respiratory measurements and monitoring terminology.',
  },
  {
    icon: 'flask',
    title: 'The Laboratory Trend Review Worksheet',
    text: 'A framework for organizing laboratory information over time and identifying contextual questions for further review.',
  },
  {
    icon: 'brain',
    title: 'The Clinical Case Reasoning Template',
    text: 'A guided structure for recording case information, relevant findings, uncertainties, and educational reasoning.',
  },
  {
    icon: 'list',
    title: 'The Critical Care Concept Checklists',
    text: 'Structured checklists to help you review selected topics and identify areas you want to study further.',
  },
];

export const offerStack = [
  { kind: 'volume', label: 'Critical Care Nursing Blueprint™ — 6 Premium Volumes', value: '$162' },
  { kind: 'bonus', label: 'Bonus #1 — Critical Care Nursing Quick-Reference Cards', value: '$17' },
  { kind: 'bonus', label: 'Bonus #2 — The 10-Minute Critical Care Study Review', value: '$12' },
  { kind: 'bonus', label: 'Bonus #3 — The Critical Care Interpretation Mistakes Library', value: '$17' },
  { kind: 'bonus', label: 'Bonus #4 — Critical Care Clinical Case Practice Pack', value: '$17' },
  { kind: 'bonus', label: 'Bonus #5 — Critical Care Nursing Assessment Checklist Collection', value: '$12' },
];

export const offerIncludes = [
  'Six premium educational volumes',
  'Five complementary bonuses',
  'Organized reference tables and worksheets',
  'Educational case exercises',
  'No monthly subscription',
];

export const guaranteeItems = [
  'All six educational volumes.',
  'The hemodynamic monitoring references.',
  'The respiratory assessment materials.',
  'The laboratory and assessment resources.',
  'The educational case exercises.',
  'All five complementary bonuses.',
];

export const finalIncludes = [
  'Six premium educational volumes',
  'Five exclusive educational bonuses',
  'Visual reference tables and comparison tools',
  'Practical worksheets and checklists',
  'Simulated clinical case exercises',
];

export const buyers = [
  { name: 'María G.', country: 'Mexico', minutes: 2 },
  { name: 'Carlos R.', country: 'Colombia', minutes: 4 },
  { name: 'Valentina T.', country: 'Argentina', minutes: 1 },
  { name: 'José M.', country: 'Spain', minutes: 6 },
  { name: 'Camila R.', country: 'Chile', minutes: 3 },
  { name: 'Luis F.', country: 'Peru', minutes: 5 },
  { name: 'Daniela H.', country: 'Ecuador', minutes: 2 },
  { name: 'Andrés M.', country: 'Venezuela', minutes: 7 },
  { name: 'Gabriela C.', country: 'Guatemala', minutes: 3 },
  { name: 'Sofía V.', country: 'Costa Rica', minutes: 1 },
  { name: 'Diego N.', country: 'Uruguay', minutes: 8 },
  { name: 'Lucía M.', country: 'Dominican Republic', minutes: 4 },
  { name: 'Fernanda R.', country: 'Bolivia', minutes: 2 },
  { name: 'Javier O.', country: 'Puerto Rico', minutes: 5 },
  { name: 'Paula J.', country: 'Panama', minutes: 3 },
  { name: 'Mateo S.', country: 'Paraguay', minutes: 6 },
];
